import { memo } from 'react';
import { Helmet } from 'react-helmet-async';

import { useIdentityUser } from '@/js/libs/use-auth';

const ALLOWED_HOSTS = ['adconsole.ch', 'www.adconsole.ch', 'dev.adconsole.ch', 'dev.adconsole.com', 'app.adconsole.com'];

export const UsersnapScript = memo(function UsersnapScript() {
  const user = useIdentityUser();

  if (!user || !ALLOWED_HOSTS.includes(window.location.hostname)) {
    return null;
  }

  return (
    <Helmet>
      <script type='text/javascript' id='usersnap'>
        {`
          (function initUsersnap() {
            window.onUsersnapLoad = function (api) {
              window.Usersnap = api;
              api.init({
                user: {
                  userId: ${JSON.stringify(user.id.toString())},
                  email: ${JSON.stringify(user.email)},
                },
              });
            };
            var script = document.createElement('script');
            script.defer = 1;
            script.src = 'https://widget.usersnap.com/global/load/549d1dec-b5cd-4f6d-9f2e-5a625172662a?onload=onUsersnapLoad';
            document.getElementsByTagName('head')[0].appendChild(script);
          }());
        `}
      </script>
    </Helmet>
  );
});
